export default __webpack_public_path__ + "static/media/wave-tr.6229c48f.svg";